const GET_MENU_ITEMS = `
  query {
    getMenuItems @client
  }
`;

const GET_USER_EDITABLE_ENTITIES = `
 query getEntitySchemas($canDoActions: [String]){
    getEntitySchemas(
      userEditable: true,
      canDoActions: $canDoActions
    ){
      id,
      displayName,
      displayNamePlural,
      actions,
      properties,
      relations,
      formProperties,
      displayProperties,
      extras
    }
  }
`;

export { GET_MENU_ITEMS, GET_USER_EDITABLE_ENTITIES };
